export const mutations = { 
	//mutateShoppingCartLoading: ( state, value ) => state.shoppingCartLoading = value,
	mutateLocale: (state, value) => state.locale = value,
	mutateShoppingCartLoading: ( state, value ) => (value) ? state.shoppingCartLoading = value : setTimeout(() => { state.shoppingCartLoading = value }, 0),
	mutateShoppingCart: ( state, value ) => state.shoppingCart = value,
	mutateGlobalMessage: ( state, value ) => state.globalMessage = value,
	mutateUserData: (state, data) => { 
		state.loggedIn = (data.tipo == 'procure' || data.tipo == 'checkout') ? true : false 
		state.username = data.nombre
		state.userEmail = data.email
		state.sessionType = data.tipo
		state.sessionEndTime = new Date(Date.now() + ( data.ending * 1000 )).toString()
		state.userSrv = data.srv
	},
	mutatePunchOutUrl: (state, value) => state.punchOutUrl = value,
	mutateServices (state, value) { state.services = value },
	mutateSelectedService (state, value) { state.selectedService = localStorage.selectedService = value },
	mutateSelectedFavlist (state, value) { state.selectedFavlist = localStorage.selectedFavlist = value },
	mutateAdVisibility (state, value) { state.adVisibility = sessionStorage.adVisibility = value },
	mutateLoggedIn (state, value) { state.loggedIn = value },
};
